import React from "react";
import { FaIcon } from "lib/FaIcon";
import { ReactComponent as Logo } from "../../login/images/logo.svg";
import ErrorBoundary from "lib/ErrorBoundary";
import useIsMobile from "lib/hooks/useIsMobile";
import { BiLink } from "lib/routing";
import { auditAdvertClick } from "lib/analytics/auditEvents";
import "./advert2.scss";

export const AdvertCard2 = ({ advert }) => {
  const {
    icon,
    text1,
    text2,
    text3,
    isSecondText,
    isEyebrow,
    isExploreBtn,
    isPlayBtn,
    btnText,
    isImage,
    selectedSize1,
    selectedSize2,
    selectedSize3,
    selectedMobileSize1,
    selectedMobileSize2,
    selectedMobileSize3,
    selectedMargin1,
    selectedMargin2,
    selectedMargin3,
    templateStyles,
    shadow,
    mobileTemplateStyles,
    selectedFontWeight,
    buttonPosition,
    isLogo,
    logoColor = "primary",
    selectedColor1,
    selectedColor2,
    selectedColor3,
    selectedFontWeight1,
    selectedFontWeight2,
    selectedFontWeight3,
    selectedCTAMargin,
    selectedCTASize,
    backgroundPosition,
    exploreBtnBgColor,
    exploreBtnColor
  } = JSON.parse(advert.style_json_text);

  const { secondary_text_link, CTA_button_link } = advert;
  const hasIndividualLinks = secondary_text_link || CTA_button_link;

  let { redesignFontStyle1, redesignFontStyle2, redesignFontStyle3 } = JSON.parse(advert.style_json_text);

  // handling legacy code (where the json does not have a style for new UI)
  if (redesignFontStyle1 === undefined) redesignFontStyle1 = { fontSize: "1rem" };
  if (redesignFontStyle2 === undefined) redesignFontStyle2 = { fontSize: ".8rem" };
  if (redesignFontStyle3 === undefined) redesignFontStyle3 = { fontSize: ".8rem" };

  const getBackgroundPosition = () => {
    let positions = [];
    for (let position in backgroundPosition) {
      if (backgroundPosition[position]) {
        positions.push(position);
      }
    }
    return positions.join(" ");
  };

  const isMobile = useIsMobile();

  return (
    <ErrorBoundary>
      <section
        className="banner"
        style={
          isMobile
            ? { ...templateStyles, ...mobileTemplateStyles, backgroundPosition: getBackgroundPosition() }
            : { ...templateStyles, backgroundPosition: getBackgroundPosition() }
        }
      >
        {hasIndividualLinks ? (
          <div className={`banner-content ${selectedColor1}`}>
            <div className="play-container text-main">
              {isPlayBtn && (
                <BiLink onClick={auditAdvertClick(advert)} to={advert.url} className="banner-link-item">
                  <FaIcon icon="fa-fw far fa-play-circle fa-2x  fas fa-2x fa-fw mr-1  align-middle" />
                </BiLink>
              )}
            </div>
            <article style={{ textShadow: shadow }}>
              {isLogo && (
                <BiLink onClick={auditAdvertClick(advert)} to={advert.url} className="banner-link-item">
                  <Logo
                    className={`d-block text-primary fill-${logoColor} bg-transparent mx-0`}
                    style={{ maxWidth: "100px", maxHeight: "25px" }}
                  />
                </BiLink>
              )}
              <BiLink onClick={auditAdvertClick(advert)} to={advert.url} className={`banner-link-item ${selectedColor1}`}>
                <div className="primary-group">
                  {isEyebrow && (
                    <p
                      className={`text3 ${selectedSize3} ${selectedMobileSize3} ${selectedMargin3} ${selectedColor3} ${selectedFontWeight3}`}
                    >
                      {text3}
                    </p>
                  )}
                  <p
                    className={`text1 ${selectedSize1} ${selectedMobileSize1} ${selectedMargin1} ${selectedFontWeight} ${selectedColor1}  ${selectedFontWeight1}`}
                  >
                    {text1}
                  </p>
                </div>
              </BiLink>
              {isSecondText && (
                <BiLink onClick={auditAdvertClick(advert)} to={secondary_text_link || advert.url} className={`banner-link-item ${selectedColor2}`}>
                  <p
                    className={`text2 ${selectedSize2} ${selectedMobileSize2} ${selectedMargin2} ${selectedColor2}  ${selectedFontWeight2}`}
                  >
                    {text2}
                  </p>
                </BiLink>
              )}
              {isExploreBtn && (
                <div style={{ display: "flex", justifyContent: buttonPosition }} className={`${selectedCTAMargin}`}>
                  <BiLink
                    onClick={auditAdvertClick(advert)}
                    to={CTA_button_link || advert.url}
                    className={`btn btn-secondary ${selectedCTASize ? selectedCTASize : "h5"} py-0`}
                    style={{ backgroundColor: exploreBtnBgColor, color: exploreBtnColor }}
                  >
                    {btnText}
                  </BiLink>
                </div>
              )}
            </article>
          </div>
        ) : (
          <BiLink onClick={auditAdvertClick(advert)} to={advert.url} className={`banner-link ${selectedColor1}`}>
            <div className="play-container text-main">
              {isPlayBtn && <FaIcon icon="fa-fw far fa-play-circle fa-2x  fas fa-2x fa-fw mr-1  align-middle" />}
            </div>
            <article style={{ textShadow: shadow }}>
              {isLogo && (
                <Logo
                  className={`d-block text-primary fill-${logoColor} bg-transparent mx-0`}
                  style={{ maxWidth: "100px", maxHeight: "25px" }}
                />
              )}
              {isEyebrow && (
                <p
                  className={`text3 ${selectedSize3} ${selectedMobileSize3} ${selectedMargin3} ${selectedColor3} ${selectedFontWeight3}`}
                >
                  {text3}
                </p>
              )}
              <p
                className={`text1 ${selectedSize1} ${selectedMobileSize1} ${selectedMargin1} ${selectedFontWeight} ${selectedColor1}  ${selectedFontWeight1}`}
              >
                {text1}
              </p>
              {isSecondText && (
                <p
                  className={`text2 ${selectedSize2} ${selectedMobileSize2} ${selectedMargin2} ${selectedColor2}  ${selectedFontWeight2}`}
                >
                  {text2}
                </p>
              )}
              {isExploreBtn && (
                <div style={{ display: "flex", justifyContent: buttonPosition }} className={`${selectedCTAMargin}`}>
                  <button
                    style={{ backgroundColor: exploreBtnBgColor, color: exploreBtnColor }}
                    className={`btn btn-secondary ${selectedCTASize ? selectedCTASize : "h5"} py-0`}
                  >
                    {btnText}
                  </button>
                </div>
              )}
            </article>
          </BiLink>
        )}
        {isImage && (
          <section>
            <img className="additional-image" alt="secondary" src={icon} />
          </section>
        )}
      </section>
    </ErrorBoundary>
  );
};
